import React, { useState } from "react";
import styled from "styled-components";
import { useDataContex } from "../../../hooks/Context/PatientProvider";
import Swal from "sweetalert2";
import { IPatientTime } from "../../../interfaces/Patient";

const LargerRadioInput = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

//Nueva version de las horas

const Body = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
`;

const Element = styled.div`
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #494949;
  align-items: center;
  text-align: center;
  width: 150px;
  background-color: #f2f2f2;
  margin: 10px;
  border-bottom: 1px solid #e0e0e0;
  padding: 0.5rem;
  border-radius: 5px;

  @media (max-width: 600px) {
    width: 140px;
  }

  @media (max-width: 320px) {
    width: 120px;
  }
`;

const Title = styled.h3`
  background-color: #0181ae;
  font-weight: bold;
  color: white;
  padding: 0.45rem;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const NoHours = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 400px;
  margin: 10px;
  padding: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 10px;

  p {
    color: #707070;
    font-family: "Roboto", sans-serif;
    font-weight: bold;
    font-size: 1.3rem;
    text-align: center;
  }
`;

export const TablaTime = ({newPatient = false}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const { setTimeData, TimeData, CalendarData } = useDataContex();
  const dataSet = TimeData?.[TimeData.length - 1];
  const [formData, setFormData] = useState<IPatientTime>();

  const handleRadioChange = (event) => {
    const selectedHour = event.target.value;
    setSelectedOption(selectedHour);
    const displayHour1 =
      Number(selectedHour) % 12 === 0 ? 12 : Number(selectedHour) % 12;
    const HoraSelectedFinal = Number(selectedHour) < 12 ? ":00 AM" : ":00 PM";
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: "Bien!",
      text: "Hora seleccionada: " + displayHour1 + HoraSelectedFinal,
      showConfirmButton: false,
      timer: 2000,
    });
    const newFormData = {
      appointmentTime: {
        field: selectedHour,
        isValid: true,
        date: selectedHour,
      },
    };
    setFormData(newFormData);
    setTimeData([newFormData]);
  };

  return (
    <Main>
      <Title>HORAS DISPONIBLES</Title>
      {CalendarData &&
        CalendarData[0] &&
        CalendarData[0].DateCalendar &&
        CalendarData[0].DateCalendar.hours.length > 0 ? (
        newPatient === true ? (
          <Body>
            {CalendarData[0].DateCalendar.hours
              .filter((hour) => Number(hour) >= 8 && Number(hour) <= 16)
              .map((hour) => {
                const displayHour =
                  Number(hour) % 12 === 0 ? 12 : Number(hour) % 12;
                const amPm = Number(hour) < 12 ? ":00 AM" : ":00 PM";
                return (
                  <Element key={hour}>
                    {displayHour}
                    {amPm}
                    <LargerRadioInput
                      name="time"
                      type="radio"
                      value={hour}
                      onChange={handleRadioChange}
                    />
                  </Element>
                );
              })}
          </Body>) :
          (
            <Body>
              {CalendarData[0].DateCalendar.hours
                .map((hour) => {

                  const displayHour =
                    Number(hour) % 12 === 0 ? 12 : Number(hour) % 12;
                  const amPm = Number(hour) < 12 ? ":00 AM" : ":00 PM";
                  return (
                    <Element key={hour}>
                      {displayHour}
                      {amPm}
                      <LargerRadioInput
                        name="time"
                        type="radio"
                        value={hour}
                        onChange={handleRadioChange}
                      />
                    </Element>
                  );
                })}
            </Body>
          )
      ) : (
        <NoHours>
          <p>No hay horas disponibles en esta fecha.</p>
        </NoHours>
      )}
    </Main>
  );
};
